import { render, staticRenderFns } from "./ListarRelatorioFaq.vue?vue&type=template&id=3a8512f0&"
import script from "./ListarRelatorioFaq.vue?vue&type=script&lang=js&"
export * from "./ListarRelatorioFaq.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports